import { useKeenSlider } from 'keen-slider/react'
import { useWindowSize } from 'react-use'

export function useGetCarousel() {
  const window = useWindowSize()
  const width = Math.min(window.width, 1200)
  const isDesktop = width >= 800

  const cardWidth = isDesktop ? 550 : 286

  const sliderOptions = {
    slides: {
      spacing: isDesktop ? 32 : 16,
      perView: Math.min(Math.max(width / cardWidth, 1), 2),
    },
  }

  return useKeenSlider(sliderOptions)
}
